import { Component, Optional, Inject, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgModel, NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS, FormArray, FormGroup, FormBuilder, Validators, } from '@angular/forms';
import { ElementBase } from 'src/app/core/form/element-base';
import { MenuComponent } from '../../../inputs/menu/menu.component';
import { IsicComponent } from '../../../modals/isic/isic.component';

@Component({
    selector: 'app-insurance-passengers',
    templateUrl: './insurance-passengers.component.html',
    styleUrls: ['./insurance-passengers.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: InsurancePassengersComponent, multi: true }
    ]
})
export class InsurancePassengersComponent extends ElementBase<any> {
    @Input() mobileMode = false;
    @Input() viajeros = false;
    form: FormGroup;
    @ViewChild(NgModel) model: NgModel;
    @Output() formUpdate: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('menuModal') menuModal: MenuComponent;
    @ViewChild('modal') modal: IsicComponent;
    submited: any = false;

    constructor(
        private _f: FormBuilder,
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
    ) {
        super(validators, asyncValidators);
        this.buildForm();
    }

    buildForm() {
        this.form = this._f.group({
            numPassangers: [1, []],
            passengers: this._f.array([])
        });

        this.form.get('numPassangers').valueChanges.subscribe(value => {
            this.passengerArray = value;
        });

        // this.form.get('hasIsic').valueChanges.subscribe(data => {
        //   this.form.get('isic').setValue('');
        // });

        this.passengerArray = 1;

        this.form.valueChanges.subscribe(data => {
            // console.log('Insurance passengers: ', data);
            this.value = data;
            this.updateInsurance();
        });
    }

    ngAfterContentInit(): void {
        this.updateInsurance();
    }

    get fpassengers() {
        return (this.form.get('passengers') as FormArray).controls;
    }

    get passengersArray() {
        return this.form.get('passengers') as FormArray;
    }

    set passengerArray(length) {
        // console.log("SetPasajero");

        let i = (this.form.get('passengers') as FormArray).length;
        while (i !== length) {
            if (i < length) {
                // console.log('Set pasajero: ', i, length);
                const grupo = this._f.group({
                    hasIsic: [false, []],
                    isic: ['', [Validators.required]],
                    age: [6, [Validators.min(6), Validators.max(70)]]
                });
                (this.form.get('passengers') as FormArray).push(grupo);
                grupo.get('isic').disable();

                grupo.get('hasIsic').valueChanges.subscribe((data: any) => {
                    // console.log('Data hasIsic:', data);
                    if (data) {
                        // console.log('Activado');
                        grupo.get('isic').enable();
                    } else {
                        // console.log('Desactivado');
                        grupo.get('isic').disable();
                    }
                }, (err) => {
                    console.error('Error :', err);
                });

            } else {
                (this.form.get('passengers') as FormArray).removeAt(i - 1);
            }
            i = (this.form.get('passengers') as FormArray).length;
        }
    }

    addPassenger(value) {
        const newTotal = value + this.form.get('numPassangers').value;
        if (newTotal >= 1 && newTotal <= 9) {
            this.form.get('numPassangers').setValue(newTotal);
        }
    }

    isicFormat(e, passenger) {
        if (typeof e.target.lastValue === 'undefined') {
            e.target.lastValue = '';
        }
        const value = e.target.value.split(' ').join('').toUpperCase();
        if (value === '' || /^[a-zA-ZñÑ]{1}[0-9]{0,12}$/.test(value) || /^[a-zA-ZñÑ]{1}[0-9]{12}[a-zA-ZñÑ]{1}$/.test(value)) {
            const newVal = value.replace(/(\d{3})/g, '$1 ').replace(/([a-zA-ZñÑ]{1})/g, '$1 ').replace(/(^\s+|\s+$)/, '');
            e.target.value = newVal;
            e.target.lastValue = value;
            passenger.get('isic').setValue(newVal);
        } else {
            e.target.value = e.target.lastValue.replace(/(\d{3})/g, '$1 ').replace(/([a-zA-ZñÑ]{1})/g, '$1 ').replace(/(^\s+|\s+$)/, '');
            passenger.get('isic').setValue(e.target.value);
        }
    }

    updateInsurance() {
        // console.log('Input pasajero: ', this.form);

        // Actualiza Output
        if (this.form.valid) {
            this.formUpdate.emit(this.form.value);
        } else {
            this.formUpdate.emit(null);
        }
    }

    closeModal() {
        this.submited = true;
        if (this.form.valid) {
            this.menuModal.closeMenu();
        }
    }

    openModal() {
        this.modal.openModal();
    }

    focusOutFunction() {
        console.log('Al Salir del Input' );

        // this.form.controls['age'].setValue(70);
    }
}
